import { Navigate, useLocation } from "react-router-dom";
import useAuthStore from "../../store/authStore";

const PrivateRoute = ({ children, requiredRoles = [] }) => {
  const { isAuthenticated, user, isLoading } = useAuthStore();
  const location = useLocation();

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/signin" state={{ from: location }} replace />;
  }

  if (requiredRoles.length > 0 && !requiredRoles.includes(user?.role)) {
    return <Navigate to="/restricted-page" replace />;
  }

  return <>{children}</>;
};

export default PrivateRoute;
